import { render, staticRenderFns } from "./InstanceManager.vue?vue&type=template&id=8009d07c&scoped=true&"
import script from "./InstanceManager.vue?vue&type=script&lang=js&"
export * from "./InstanceManager.vue?vue&type=script&lang=js&"
import style0 from "./InstanceManager.vue?vue&type=style&index=0&id=8009d07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8009d07c",
  null
  
)

export default component.exports